<template>
  <div>
    <MainNavigation
      page-name="Past Sessions"
      :routeIndex="routeIndex"
      :currentClass="currentClass"
    />
    <Loader v-if="!currentClass || !sortedSessions" />
    <section v-if="currentClass && sortedSessions">
      <ClassItemBanner
        v-if="currentClass"
        :sessionEnded="true"
        :currentClass="currentClass"
      />
      <h1>Select a Session:</h1>

      <div
        v-for="session in sortedSessions"
        :key="session.sessionId"
        @click="viewAnalytics(session.sessionId)"
        class="session-item"
      >
        <div>
          <img
            class="forward-button"
            src="@/assets/arrow_forward_ios_24px.svg"
          />
          <h2>
            <strong>{{ getDate(session.startTime) }}</strong>
            {{ getTime(session.startTime) }}
          </h2>
          <p v-if="session.storyboxId">
            {{ storyBoxName(session.storyboxId) }},
            {{ levelName(session.levelId) }}
          </p>
          <p v-if="session.isTimeLimitEnabled">
            Session Length: {{ session.timeLimit }}mins
          </p>
          <p v-if="!session.isTimeLimitEnabled">No Time Limit</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import MainNavigation from "../components/MainNavigation.vue";
import ClassItemBanner from "../components/ClassItemBanner.vue";
import Loader from "../components/Loader.vue";

export default {
  name: "PastSessions",
  components: {
    MainNavigation,
    ClassItemBanner,
    Loader,
  },
  props: ["name", "routeIndex"],
  data() {
    return {
      items: [
        {
          date: "Fri, September 24, 2021",
          groupName: "Florence Mills, Harlem Renaissance",
          sessionLength: "40:00",
        },
        {
          date: "Fri, September 17, 2021",
          groupName: "Florence Mills, Blackbirds",
          sessionLength: "40:00",
        },
      ],
    };
  },
  computed: {
    allClasses() {
      return this.$store.state.allClasses;
    },
    currentClass() {
      const result = this.allClasses.filter((response) => {
        return response.classInfo.nickname === this.$route.params.name;
      });
      return result[0];
    },
    pastSessions() {
      return this.$store.state.pastSessionsBrief;
    },
    sortedSessions() {
      let entries = Object.entries(this.pastSessions);
      let sorted = entries.sort((a, b) => b[1].startTime - a[1].startTime);
      var objects = sorted.map((key) => key[1]);
      return objects;
    },
  },
  methods: {
    viewAnalytics: function (sessionId) {
      // console.log(this.$store.state.currentClass)
      this.$store.commit("SET_SESSION_ID", sessionId);
      this.$store.commit("SEND_MESSAGE", {
        data: sessionId,
        opCode: this.$store.state.opCodes.PastSessionData,
      });
      this.$router.push({
        name: "session-analytics",
        params: {
          name: this.currentClass.classInfo.nickname,
          session: sessionId,
        },
      });
    },
    getDate: function (timestamp) {
      return this.$filters.getDate(timestamp);
    },
    getTime: function (timestamp) {
      return this.$filters.getTime(timestamp);
    },
    storyBoxName: function (storyboxId) {
      return this.$filters.storyName(storyboxId);
    },
    levelName: function (levelId) {
      return this.$filters.levelName(levelId);
    },
  },
};
</script>

<style>
.session-item h2 {
  font-weight: normal;
}
</style>